module.exports = __webpack_public_path__ + "media/images/twitter-black-c68e38650d94cb587060bd56136ea112.svg";